var render = function render(){var _vm=this,_c=_vm._self._c;return _c('market-card',{staticClass:"market-gallery"},[_c('image-slider',{attrs:{"images":_vm.images}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }